import { render, staticRenderFns } from "./MyTextarea.vue?vue&type=template&id=580f94f4&scoped=true&"
import script from "./MyTextarea.vue?vue&type=script&lang=js&"
export * from "./MyTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MyTextarea.vue?vue&type=style&index=0&id=580f94f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f94f4",
  null
  
)

export default component.exports